module.exports = __webpack_public_path__ + "static/media/under-construction.a63e2b65.png";